import React from 'react';

const About = () => {
  return (
    <div name='about' className='w-full h-screen bg-[#0a192f] text-gray-300'>
      <div className='flex flex-col justify-center items-center w-full h-full'>
        <div className='max-w-[1000px] w-full grid grid-cols-2 gap-8'>
          <div className='sm:text-right pb-8 pl-4'>
            <p className='text-4xl font-bold inline border-b-4 border-pink-600'>
              About
            </p>
          </div>
          <div></div>
          </div>
          <div className='max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4'>
            <div className='sm:text-right text-4xl font-bold'>
              <p>Wanna know about me more?</p>
            </div>
            <div>
              <p>I am Tafsir Ahmed a professional MERN Stack Developer. I am working and learning in this field for last 6 months. But from my childhood I am passionate about Technologies and it's amazing features. I am never stoppable from learning. And I hope who can have a great intention of learning no one can stop him from success.</p>  
            </div>
          </div>
      </div>
    </div>
  );
};

export default About;
